import React, { Component } from "react";
import CssClasses from "./EventGroupItemLiveFootball.css";
import BetTypeButton from "../UI/BetTypeButton/BetTypeButton";
import OddButton from "../UI/OddButton/OddButton";
import SiteIcons from "../../assets/fonts/site_icons/style.css";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import Auxx from "../../HOCs/AUXX/Auxx";
//import { GetConvertedOdds } from "../../HOCs/Helpers/OddConverter";
import * as SortTypes from "../../HOCs/Constants/SortTypes";

import beepHigh from "../../assets/sounds/beep_high.mp3";
import beepMedium from "../../assets/sounds/beep_medium.mp3";

import imgPolice from "../../assets/images/icons/icon_police.png";
import imgRain from "../../assets/images/icons/icon_rain.png";
import imgMedic from "../../assets/images/icons/icon_medic.png";

class EventGroupItemLiveFootball extends Component {
  sortedHeaderButtons = [];

  state = {
    currentActiveBetTypeID: 8
  };

  componentWillUpdate() {
    //pogledaj je li se promjenio property
    // Do whatever you want
    //sortiraj headerbuttons
    this.sortedHeaderButtons = this.props.headerButtons.sort((a, b) => {
      return parseInt(a.HederRedoslijed, 10) - parseInt(b.HederRedoslijed, 10); //asc sort
    });

    //provjeri ako je nestao otvoreni extra bets
    if (this.props.liveExtraBetsID > 0) {
      //provjeri ako je nestala
      //dohvati mec
      let match = this.props.matches.find(
        x => x.id === this.props.liveExtraBetsID
      );

      //aako vise nema, zatvori
      if (match === undefined || match.extraBetsCount < 1) {
        this.props.onSetLiveExtraBetsID(-1);

        //nakon timeouta upali
        setTimeout(() => {
          this.props.setCanShowExtraLiveBets(true);
          console.log("PALIM...");
        }, 1000);
      }
    }
  }

  componentWillMount() {
    //podesi defaultni 8 i 9
    //po defaultu uvijek 9 - dupla sansa
    let newGroups = ",8,9,";
    this.props.setBetGroups(newGroups);
  }

  render() {
    //define header colors
    let titleRowClasses = [CssClasses.boxTitleRow];

    //i dodaj boju ovisno o sportu
    // switch (this.props.currentSportID) {
    //   case 1:
    //     titleRowClasses.push(CssClasses.colorFootball);
    //     break;
    //   case 2:
    //     titleRowClasses.push(CssClasses.colorBasketball);
    //     break;
    //   case 3:
    //     titleRowClasses.push(CssClasses.colorDarts);
    //     break;
    //   case 4:
    //     titleRowClasses.push(CssClasses.colorFootball);
    //     break;
    //   case 5:
    //     titleRowClasses.push(CssClasses.colorIceHockey);
    //     break;
    //   case 6:
    //     titleRowClasses.push(CssClasses.colorRugby);
    //     break;
    //   case 7:
    //     titleRowClasses.push(CssClasses.colorTableTennis);
    //     break;
    //   case 8:
    //     titleRowClasses.push(CssClasses.colorTennis);
    //     break;
    //   case 9:
    //     titleRowClasses.push(CssClasses.colorVolleyball);
    //     break;
    //   default:
    //     titleRowClasses.push(CssClasses.colorFootball);
    //     break;
    // }

    let rowCounter = 0;

    //sortiraj po vremenu silazno
    // let sortedMatches = this.props.matches.sort((a, b) => {
    //   return parseInt(b.currentTime, 10) - parseInt(a.currentTime, 10); //reverse sort
    // });

    //let sortedMatches = this.props.matches;

    let sortedMatches = [];

    if (this.props.currentSortType === SortTypes.SORT_TIME_DESC) {
      //vrijeme silazno
      sortedMatches = this.props.matches.sort(function(a, b) {
        if (a.timeMatchStartDiff === b.timeMatchStartDiff) {
          if (a.tournamentName === b.tournamentName) {
            return a.homeTeam > b.homeTeam ? 1 : -1;
          } else if (a.tournamentName > b.tournamentName) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.timeMatchStartDiff > b.timeMatchStartDiff) {
          return 1;
        } else {
          return -1;
        }
      });
    } else if (this.props.currentSortType === SortTypes.SORT_TIME_ASC) {
      //vrijeme silazno
      sortedMatches = this.props.matches.sort(function(a, b) {
        if (a.timeMatchStartDiff === b.timeMatchStartDiff) {
          if (a.tournamentName === b.tournamentName) {
            return a.homeTeam > b.homeTeam ? 1 : -1;
          } else if (a.tournamentName > b.tournamentName) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.timeMatchStartDiff > b.timeMatchStartDiff) {
          return -1;
        } else {
          return 1;
        }
      });
    } else if (this.props.currentSortType === SortTypes.SORT_LEAGUE_AZ) {
      //vrijeme silazno
      sortedMatches = this.props.matches.sort(function(a, b) {
        if (a.tournamentName === b.tournamentName) {
          return a.homeTeam > b.homeTeam ? 1 : -1;
        } else if (a.tournamentName > b.tournamentName) {
          return 1;
        } else {
          return -1;
        }
      });
    }

    //console.log("SORTED ", sortedMatches);

    //define middle section markup
    let middleSectionHeaderMarkup = this.getMiddleSectionTitleMarkup(
      this.state.currentActiveBetTypeID,
      sortedMatches
    );

    //print debug test
    //console.log("MATCHES: ", sortedMatches);

    let lastLeagueName = "";
    let mainBetHeaderTitle = "";

    //nadji svoid
    let betTexts = this.props.allBetsText
      .filter(x => x.SportID === 1)
      .map(x => x.svoID); //fudbol
    //let bets = this.
    let bet = this.props.allBets.find(
      x => betTexts.includes(x.svoID) && x.kpID === 1
    );

    if (bet) {
      mainBetHeaderTitle = this.props.allBetsText.find(
        x => x.svoID === bet.svoID
      ).HederNaziv;
    } else {
      mainBetHeaderTitle = "-";
    }

    return (
      <div className={CssClasses.container}>
        <audio
          ref={sound => {
            this.beepHigh = sound;
          }}
        >
          <source src={beepHigh} type="audio/mpeg" />
        </audio>
        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        <div className={CssClasses.boxBetTypes}>
          {this.sortedHeaderButtons.map(btnInfo => {
            let isActive =
              btnInfo.svoID === this.state.currentActiveBetTypeID &&
              !this.props.isShowingBonusInfo;

            //ako je trenutno kurac vani
            if (this.props.liveExtraBetsID > 0) {
              isActive = false;
            }

            return (
              <BetTypeButton
                onButtonClicked={id => this.btnChangeBetTypeClick(id)}
                title={btnInfo.HederNaziv}
                key={btnInfo.svoID}
                id={btnInfo.svoID}
                isActive={isActive}
                inLiveEventGroup={true}
                isLightTheme={this.props.currentActiveLiveTheme === 2}
                sportID={1}
              />
            );
          })}
        </div>
        <div className={titleRowClasses.join(" ")}>
          &nbsp;
          {/* last column for button +102 */}
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            &nbsp;
          </div>
          {/* middle section */}
          {middleSectionHeaderMarkup}
          {/* main left section */}
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            1/2
          </div>
          <div className={CssClasses.oddBox}>
            X2
            <div className={CssClasses.oddBoxTitle}>Dupla šansa</div>
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            1X
          </div>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            2
          </div>
          <div className={CssClasses.oddBox}>
            X<div className={CssClasses.oddBoxTitle}>{mainBetHeaderTitle}</div>
          </div>
          <div className={CssClasses.oddBox}>1</div>
        </div>

        <div className={CssClasses.matchesContainer}>
          {sortedMatches.map(match => {
            let availableBets = match.betInfo;
            rowCounter++;

            let rowClasses = [CssClasses.boxEventItem];
            if (rowCounter % 2 === 1) {
              rowClasses.push(CssClasses.alternateRow);
            }

            let hasGroup =
              lastLeagueName !== match.tournamentName &&
              this.props.currentSortType === SortTypes.SORT_LEAGUE_AZ;

            lastLeagueName = match.tournamentName;

            //daj random error
            let pauseReason = parseInt((Math.random() * 20).toFixed(0), 10);

            //pauseReason = 2;

            //console.log("PAUES ", pauseReason);

            return (
              <Auxx key={match.id}>
                {hasGroup ? (
                  <div className={CssClasses.leagueHeader}>
                    {match.tournamentName}
                  </div>
                ) : null}

                <div className={[rowClasses.join(" ")]}>
                  {/* skriveni span s idem */}
                  <span style={{ display: "none" }}>ID: {match.id}</span>

                  <div className={CssClasses.timeBox}>
                    <span
                      className={[
                        CssClasses.currentTime
                        //,match.currentTime.indexOf("'") > -1 ? CssClasses.flickers : "" // ako ima oznaku minute onda je u tijeku pa neka blica
                      ].join(" ")}
                    >
                      {match.currentTime}
                    </span>
                  </div>

                  {pauseReason === 1 ? (
                    <img
                      src={imgMedic}
                      className={CssClasses.interruptionIcon}
                      alt=""
                    />
                  ) : pauseReason === 2 ? (
                    <img
                      src={imgPolice}
                      className={CssClasses.interruptionIcon}
                      alt=""
                    />
                  ) : pauseReason === 3 ? (
                    <img
                      src={imgRain}
                      className={CssClasses.interruptionIcon}
                      alt=""
                    />
                  ) : null}

                  <div className={CssClasses.matchInfoContainer}>
                    <div className={CssClasses.homeTitle}>
                      <span
                        className={[
                          match.homeChangeDirection > 0
                            ? CssClasses.flickers
                            : ""
                        ].join(" ")}
                      >
                        {match.homeTeam}
                      </span>
                    </div>
                    <div className={CssClasses.homeCards}>
                      {this.getYellowRedCardsMarkup(
                        parseInt(match.redCardsHome, 10),
                        parseInt(match.yellowToRedCardsHome, 10),
                        match.specFlagHome
                      )}
                    </div>
                    <div className={CssClasses.currentScore}>
                      <span
                        className={[
                          match.homeChangeDirection > 0
                            ? CssClasses.flickers
                            : ""
                        ].join(" ")}
                      >
                        {match.scoreHome}
                      </span>
                      &nbsp;:&nbsp;
                      <span
                        className={[
                          match.guestChangeDirection > 0
                            ? CssClasses.flickers
                            : ""
                        ].join(" ")}
                      >
                        {match.scoreGuest}
                      </span>
                    </div>
                    <div className={CssClasses.guestCards}>
                      {this.getYellowRedCardsMarkup(
                        parseInt(match.redCardsGuest, 10),
                        parseInt(match.yellowToRedCardsGuest, 10),
                        match.specFlagGuest
                      )}
                    </div>
                    <div className={CssClasses.guestTitle}>
                      <span
                        className={[
                          match.guestChangeDirection > 0
                            ? CssClasses.flickers
                            : ""
                        ].join(" ")}
                      >
                        {match.guestTeam}
                      </span>
                    </div>
                  </div>

                  {/* button for extra bets +102 */}

                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.withLeftBorder,
                      CssClasses.withLeftPadding
                    ].join(" ")}
                  >
                    <OddButton
                      onButtonClicked={matchID =>
                        this.btnShowAdditionalBetsClick(matchID)
                      }
                      moreBetsCount={match.extraBetsCount}
                      matchID={match.id}
                      isMoreBets={true}
                      moreBetsClass={CssClasses.moreBetsBtnOutline}
                      isActive={this.props.liveExtraBetsID === match.id}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>
                  {/* middle section buttons (special bets from header) */}
                  {this.getMiddleSectionOddButtonsMarkup(
                    this.state.currentActiveBetTypeID,
                    availableBets,
                    match
                  )}
                  {/* main (left) section buttons - double chance  */}
                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.withRightPadding
                    ].join(" ")}
                  >
                    <OddButton
                      onButtonClicked={(matchID, betID) =>
                        this.btnChangeBetClick(matchID, betID)
                      }
                      betInfo={availableBets.find(
                        x => x.sportVrstaOkladaID === 9 && x.order === 3 // 9 je double chance kladjenje
                      )}
                      activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>
                  <div className={CssClasses.oddBox}>
                    <OddButton
                      onButtonClicked={(matchID, betID) =>
                        this.btnChangeBetClick(matchID, betID)
                      }
                      betInfo={availableBets.find(
                        x => x.sportVrstaOkladaID === 9 && x.order === 2 // 9 je double chance kladjenje
                      )}
                      activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>
                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.withLeftBorder,
                      CssClasses.withLeftPadding
                    ].join(" ")}
                  >
                    <OddButton
                      onButtonClicked={(matchID, betID) =>
                        this.btnChangeBetClick(matchID, betID)
                      }
                      betInfo={availableBets.find(
                        x => x.sportVrstaOkladaID === 9 && x.order === 1 // 9 je double chance kladjenje
                      )}
                      activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>
                  {/* main (left) section buttons - main bets  */}
                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.withRightPadding
                    ].join(" ")}
                  >
                    <OddButton
                      onButtonClicked={(matchID, betID) =>
                        this.btnChangeBetClick(matchID, betID)
                      }
                      betInfo={availableBets.find(
                        x => x.kategorijaPonudeID === 1 && x.order === 3
                      )}
                      activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>
                  <div className={CssClasses.oddBox}>
                    {" "}
                    <OddButton
                      onButtonClicked={(matchID, betID) =>
                        this.btnChangeBetClick(matchID, betID)
                      }
                      betInfo={availableBets.find(
                        x => x.kategorijaPonudeID === 1 && x.order === 2
                      )}
                      activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>
                  <div className={CssClasses.oddBox}>
                    {" "}
                    <OddButton
                      onButtonClicked={(matchID, betID) =>
                        this.btnChangeBetClick(matchID, betID)
                      }
                      betInfo={availableBets.find(
                        x => x.kategorijaPonudeID === 1 && x.order === 1
                      )}
                      activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
                      oddType={this.props.currentOddFormat}
                    />
                  </div>

                  <div
                    className={[
                      CssClasses.oddBox,
                      CssClasses.statsCustomOddBox
                    ].join(" ")}
                  >
                    <span
                      className={[
                        SiteIcons.site_icon_statistics,
                        CssClasses.statsIcon
                      ].join(" ")}
                    />
                  </div>
                </div>
              </Auxx>
            );
          })}
        </div>
      </div>
    );
  }

  getYellowRedCardsMarkup = (redCards, yellowToRedCards, specFlag) => {
    // if (yellowToRedCards > 0) {
    //   //vrati yellow + red
    //   return (
    //     <div>
    //       <span
    //         className={[
    //           SiteIcons.site_icon_card_yellow_single,
    //           CssClasses.firstCard
    //         ].join(" ")}
    //       />
    //       <span
    //         className={[
    //           SiteIcons.site_icon_card_red_single,
    //           CssClasses.secondCard
    //         ].join(" ")}
    //       />
    //     </div>
    //   ); }
    //else if (yellowCards === 2 && redCards === 0) {
    //vrati 2 zuta
    // return (
    //   <div>
    //     <span
    //       className={[
    //         SiteIcons.site_icon_card_yellow_single,
    //         CssClasses.firstCard
    //       ].join(" ")}
    //     />
    //     <span
    //       className={[
    //         SiteIcons.site_icon_card_yellow_single,
    //         CssClasses.secondCard
    //       ].join(" ")}
    //     />
    //   </div>
    // );
    //return <div>&nbsp;</div>; }
    if (redCards > 1 || specFlag > 1) {
      //vrati 2 crvena
      return (
        <div>
          <span
            className={[
              SiteIcons.site_icon_card_red_single,
              CssClasses.firstCard
            ].join(" ")}
          />
          <span
            className={[
              SiteIcons.site_icon_card_red_single,
              CssClasses.secondCard
            ].join(" ")}
          />
        </div>
      );
    } //else if (yellowCards === 1 && redCards === 0) {
    //vrati 1 zuti
    // return (
    //   <span
    //     className={[
    //       SiteIcons.site_icon_card_yellow_single,
    //       CssClasses.onlyCard
    //     ].join(" ")}
    //   />
    // );

    //return <div>&nbsp;</div>;}
    else if (redCards > 0 || specFlag > 0) {
      //vrati 1 crveni
      return (
        <span
          className={[
            SiteIcons.site_icon_card_red_single,
            CssClasses.onlyCard
          ].join(" ")}
        />
      );
    }

    return <div>&nbsp;</div>;
  };

  getMiddleSectionTitleMarkup = (svoID, matches) => {
    //ako su aktivna dodatna kladjenja, nema ovog!
    if (this.props.liveExtraBetsID > 0 || !this.props.canShowExtraBetsLive) {
      return null;
    }

    //dohvati bet iz betova
    let okladaTxt = this.props.allBetsText.find(x => x.svoID === svoID);
    let coefs = [];

    for (let i = 0; i < matches.length; i++) {
      const match = matches[i];
      coefs = match.betInfo.filter(x => x.sportVrstaOkladaID === svoID);
      if (coefs.length > 0) {
        break;
      }
    }

    if (okladaTxt === undefined) {
      //BET
      console.log("ERROR: bet not found for SVOID " + svoID);
      return null;
    }

    //printaj naziv
    //console.log("BET IS ", okladaTxt);
    //console.log("BET DETAILS ", oklada);

    if (okladaTxt.BrojTipova === 2) {
      return (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            {coefs.find(x => x.order === 2) !== undefined
              ? coefs.find(x => x.order === 2).shortName
              : ""}
          </div>
          <div className={CssClasses.oddBox}>
            {coefs.find(x => x.order === 1) !== undefined
              ? coefs.find(x => x.order === 1).shortName
              : ""}
            <div className={CssClasses.oddBoxTitle}>{okladaTxt.HederNaziv}</div>
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            &nbsp;
          </div>
        </Auxx>
      );
    }

    if (okladaTxt.BrojTipova === 3) {
      return (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            {coefs.find(x => x.order === 3) !== undefined
              ? coefs.find(x => x.order === 3).shortName
              : ""}
          </div>
          <div className={CssClasses.oddBox}>
            {coefs.find(x => x.order === 2) !== undefined
              ? coefs.find(x => x.order === 2).shortName
              : ""}
            <div className={CssClasses.oddBoxTitle}>{okladaTxt.HederNaziv}</div>
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.borderInTitleRow,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            {coefs.find(x => x.order === 1) !== undefined
              ? coefs.find(x => x.order === 1).shortName
              : ""}
          </div>
        </Auxx>
      );
    }
  };

  getMiddleSectionOddButtonsMarkup = (svoID, availableBets, match) => {
    //ako su aktivna dodatna kladjenja, nema ovog!
    if (this.props.liveExtraBetsID > 0 || !this.props.canShowExtraBetsLive) {
      return null;
    }

    let betText = this.props.allBetsText.find(x => x.svoID === svoID);
    let bets = this.props.allBets.filter(
      x => x.svoID === svoID && x.UtakmicaID === match.id
    );

    bets.sort((a, b) => {
      return parseFloat(a.PosebnaVrijednost) - parseFloat(b.PosebnaVrijednost); //asc sort
    });

    if (match.id === 16063504) {
      console.log("BET TEXT ", betText);
      console.log("BETS ", bets);
      console.log("AVAILABLE BETS ", availableBets);
    }

    //nadji prvi bet
    let bet = bets[0];

    //vrati sto ti treba ovisno jel 2 ili 3 tipa
    if (betText.BrojTipova === 2) {
      return (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            <OddButton
              onButtonClicked={(matchID, betID) =>
                this.btnChangeBetClick(matchID, betID)
              }
              betInfo={
                bet !== undefined
                  ? availableBets.find(
                      x => x.betID === bet.IDOklada && x.order === 2
                    )
                  : null
              }
              activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
              oddType={this.props.currentOddFormat}
            />
          </div>
          <div className={CssClasses.oddBox}>
            <OddButton
              onButtonClicked={(matchID, betID) =>
                this.btnChangeBetClick(matchID, betID)
              }
              betInfo={
                bet !== undefined
                  ? availableBets.find(
                      x => x.betID === bet.IDOklada && x.order === 1
                    )
                  : null
              }
              activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
              oddType={this.props.currentOddFormat}
            />
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            <span className={CssClasses.oddLegend}>
              {bet !== undefined &&
              bet !== null &&
              bet.PosebnaVrijednost !== "-1"
                ? bet.PosebnaVrijednost
                : null}
            </span>
          </div>
        </Auxx>
      );
    }

    if (betText.BrojTipova === 3) {
      return (
        <Auxx>
          <div
            className={[CssClasses.oddBox, CssClasses.withRightPadding].join(
              " "
            )}
          >
            <OddButton
              onButtonClicked={(matchID, betID) =>
                this.btnChangeBetClick(matchID, betID)
              }
              betInfo={
                bet !== undefined
                  ? availableBets.find(
                      x => x.betID === bet.IDOklada && x.order === 3
                    )
                  : null
              }
              activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
              oddType={this.props.currentOddFormat}
            />
          </div>
          <div className={CssClasses.oddBox}>
            <OddButton
              onButtonClicked={(matchID, betID) =>
                this.btnChangeBetClick(matchID, betID)
              }
              betInfo={
                bet !== undefined
                  ? availableBets.find(
                      x => x.betID === bet.IDOklada && x.order === 2
                    )
                  : null
              }
              activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
              oddType={this.props.currentOddFormat}
            />
          </div>
          <div
            className={[
              CssClasses.oddBox,
              CssClasses.withLeftBorder,
              CssClasses.withLeftPadding
            ].join(" ")}
          >
            <OddButton
              onButtonClicked={(matchID, betID) =>
                this.btnChangeBetClick(matchID, betID)
              }
              betInfo={
                bet !== undefined
                  ? availableBets.find(
                      x => x.betID === bet.IDOklada && x.order === 1
                    )
                  : null
              }
              activeBets={this.props.ticketPairInfo.map(x => x.coefID)}
              oddType={this.props.currentOddFormat}
            />
          </div>
        </Auxx>
      );
    }
    //default return nis
    return null;
  };

  btnChangeBetTypeClick = id => {
    //daj zvukic
    if (this.beepHigh) {
      //daj zvukic
      this.beepHigh.play();
    }

    this.setState({ currentActiveBetTypeID: id });

    //napravi novi state
    //po defaultu uvijek 9 - dupla sansa
    let newGroups = ",9," + id + ",";

    this.props.setBetGroups(newGroups);

    //ako je trenutno kurac vani
    if (this.props.liveExtraBetsID > 0 || this.props.isShowingBonusInfo) {
      //gasi extra oklade
      this.props.onSetLiveExtraBetsID(-1);

      //gasi i help ako je vani
      this.props.setIsShowingBonusInfo(false);

      //nakon timeouta upali
      setTimeout(() => {
        this.props.setCanShowExtraLiveBets(true);
        console.log("PALIM...");
      }, 1000);
    }
  };

  btnShowAdditionalBetsClick = matchID => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    console.log("SHOW EXTRA bets click for MID " + matchID);

    //dodaj klasu da vidimo smanjivanje
    if (this.props.liveExtraBetsID === matchID) {
      //ugasi, klik na isti
      this.props.onSetLiveExtraBetsID(-1);

      //nakon timeouta upali
      setTimeout(() => {
        this.props.setCanShowExtraLiveBets(true);
        console.log("PALIM...");
      }, 1000);
    } else {
      //promjeni
      this.props.onSetLiveExtraBetsID(matchID);
      this.props.setCanShowExtraLiveBets(false);

      //ubij i info bez da moras provjeravat ako ga ima
      this.props.setIsShowingBonusInfo(false);

      console.log("GASIM...");

      //this.props.refreshDataCallback();
    }
  };

  btnChangeBetClick = (matchID, coefID) => {
    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    //console.log("Btn change bet click for MID " + matchID + " CID " + coefID);

    //gasi
    this.props.changeLanguagePickerVisibility(false);
    this.props.changeSettingsPickerVisibility(false);

    if (matchID === 0 || coefID === 0) {
      //disabled
      return;
    }

    //console.log("MATCHES ", this.props.matches);

    //nadji match
    let match = this.props.matches.find(x => x.id === matchID);
    let bet = match.betInfo.find(x => x.id === coefID);
    let sport = this.props.allSports.find(x => x.IDSport === match.sportID);

    //console.log("MATCH ", match);
    // console.log("BET ", bet);
    // console.log("SPORT ", sport);

    if (!bet.isEnabled || !bet.isShown) {
      //disabled
      return;
    }

    let oldBetInfo = this.props.ticketPairInfo.find(x => x.coefID === coefID);

    if (oldBetInfo) {
      //vec je odabran, radi remove
      this.props.onRemovePair(matchID);
    } else {
      //radi add
      console.log("Adding pair..");
      this.props.onAddPair({
        coefID: bet.id,
        betID: bet.betID,
        matchID: match.id,
        matchName:
          match.homeTeam +
          " - " +
          match.guestTeam +
          " (" +
          match.scoreHome +
          ":" +
          match.scoreGuest +
          ")",
        betName: this.getBetName(bet, match),
        pick: this.getPickName(bet, match),
        odds: bet.value,
        checked: true,
        isLive: true,
        isShown: true,
        isEnabled: true,
        isFix: false,
        currentTime: match.currentTime,
        tournamentName: match.tournamentName,
        sportName: sport.Naziv,
        sportID: sport.IDSport
      });
    }
  };

  getPickName = (bet, match) => {
    //nadji tu okladu
    let betText = this.props.allBetsText.find(
      x => x.svoID === bet.sportVrstaOkladaID
    );

    let betInfo = this.props.allBets.find(x => x.IDOklada === bet.betID);

    if (betText === undefined || betInfo === undefined) {
      return "???";
    }

    let desc = bet.longName;
    desc = desc.replace("d!", match.homeTeam).replace("g!", match.guestTeam);

    return desc;
  };

  getBetName = (bet, match) => {
    //console.log("ALL BETS TEXT ", this.props.allBetsText);
    //console.log("ALL BETS ", this.props.allBets);

    //nadji tu okladu
    let betText = this.props.allBetsText.find(
      x => x.svoID === bet.sportVrstaOkladaID
    );

    let betInfo = this.props.allBets.find(x => x.IDOklada === bet.betID);

    if (betText === undefined || betInfo === undefined) {
      return "???";
    }

    // console.log("BET ", bet);
    // console.log("BETTEXT ", betText);
    // console.log("BETINFO ", betInfo);
    // console.log("MATCH ", match);

    let desc = betText.DugiNaziv;
    //console.log("DESC IS ", desc);

    if (
      betInfo.PosebnaVrijednost &&
      betInfo.PosebnaVrijednost.indexOf(":") !== -1
    ) {
      //ima rezultat, izbaci
      desc = desc.replace("[1$] ", "");
    } else {
      //nema rezultat, ostavi kako je
      desc = desc.replace("1$", betInfo.PosebnaVrijednost);
    }

    desc = desc.replace("d!", match.homeTeam).replace("g!", match.guestTeam);

    return desc;
  };
}

const mapStateToProps = state => {
  return {
    isAppLoading: state.rrAppState.isLoading,
    ticketPairInfo: state.rrTicket.ticketPairInfo,
    prematchExtraBetsID: state.rrNavigation.prematchExtraBetsID,
    liveExtraBetsID: state.rrNavigation.liveExtraBetsID,
    currentActiveLiveTheme: state.rrAppState.currentActiveLiveTheme,
    allBetsText: state.rrSportEvent.allBetsText,
    allBets: state.rrSportEvent.allBets,
    currentLanguage: state.rrAppState.currentLanguage,
    currentOddFormat: state.rrAppState.oddFormatID,
    currentSortType: state.rrAppState.sortTypeID,
    canShowExtraBetsLive: state.rrNavigation.canShowExtraBetsLive,
    isShowingBonusInfo: state.rrNavigation.isShowingBonusInfo,
    allSports: state.rrSportEvent.initialLiveSetInfo.Sportovi
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAddPair: pairInfo => dispatch(StoreActions.AddPair(pairInfo)),
    onRemovePair: matchID => dispatch(StoreActions.RemovePair(matchID)),
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    setBetGroups: betGroups =>
      dispatch(StoreActions.ChangeCurrentBetGroups(betGroups)),
    changeSettingsPickerVisibility: isShown =>
      dispatch(StoreActions.SetSettingsPickerVisibility(isShown)),
    changeLanguagePickerVisibility: isShown =>
      dispatch(StoreActions.SetLanguagePickerVisibility(isShown)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventGroupItemLiveFootball);



// WEBPACK FOOTER //
// ./src/Components/EventGroupItemLiveFootball/EventGroupItemLiveFootball.js